import sharedModule from '../../shared.module';

class apiUtil {
    constructor($q, httpUtil, tokenProvider, authenticationService) {
        this.$q = $q;
        this.httpUtil = httpUtil;
        this.authenticationService = authenticationService;
        this.tokenProvider = tokenProvider;
    }

    getWithBearerAuth(moduleName, url, config) {
        return this.http('GET', moduleName, url, undefined, config);
    }

    postWithBearerAuth(moduleName, url, body, config) {
        return this.http('POST', moduleName, url, body, config);
    }

    putWithBearerAuth(moduleName, url, body, config) {
        return this.http('PUT', moduleName, url, body, config);
    }

    http(method, moduleName, url, body, config) {
        if (!moduleName) {
            return this.$q.reject('noModuleName');
        }

        var deferred = this.$q.defer();

        this.tokenProvider.getBearerTokenHeader(moduleName).then(headers => {
            this.httpUtil
                .http(method, url, body, {
                    ...config,
                    headers: headers
                })
                .then(deferred.resolve, (data) => {
                    if (data && data.error && data.error.code == 401) {
                        this.authenticationService.logout(true);
                    };

                    return deferred.reject(data);
                });
        }, deferred.reject);

        return deferred.promise;
    }
}

export default sharedModule.service('apiUtil', apiUtil);



// WEBPACK FOOTER //
// ./modules/shared/services/apiUtil/apiUtil.service.js